import * as PropTypes from "prop-types"
import styled from "styled-components"
import Col from "components/styled/Grid/Col"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import { VerifiedFull } from "components/icons/verifiedFull"

const Column = styled(Col)`
  && {
    padding: 0 8px;

    @media ${({ theme }) => theme.breakpoints.lg} {
      padding: 5px;
    }
  }
`
const OptionContainer = styled.div`
  position: relative;
  height: 60px;
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.paleGray};
  color: ${({ theme }) => theme.colors.gray};
  border: 2px solid ${({ theme }) => theme.colors.silver};
  border-radius: 8px;
  cursor: pointer;

  @media ${({ theme }) => theme.breakpoints.lg} {
    height: 48px;
  }

  &.selected {
    background-color: ${({ theme }) => theme.colors.skyBlue};
    border-color: ${({ theme }) => theme.colors.skyBlue};

    p {
      color: ${({ theme }) => theme.colors.white};
    }
  }

  @media (hover: hover) {
    &:hover:not(.disabled) {
      background-color: ${({ theme }) => theme.colors.skyBlue};
      border-color: ${({ theme }) => theme.colors.skyBlue};

      p {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  &.with-image {
    padding-left: 125px;

    img {
      position: absolute;
      left: 10px;
      bottom: 10px;
    }
  }

  &.disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`

const Label = styled(Typography)`
  font-size: 16px;
  line-height: 18px;
  margin: 0;
  font-weight: 500;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray};

  .selected & {
    color: ${({ theme }) => theme.colors.white};
  }
`

const SelectedIcon = styled(Icon)`
  border-radius: 11px;
  background: white;
  position: absolute;
  top: -10px;
  right: -10px;
  color: ${({ theme }) => theme.colors.deepPink};
`

const getContainerClass = (selected, image) => {
  const classes = []
  if (selected) classes.push("selected")
  if (image) classes.push("with-image")
  return classes.join(" ")
}

export default function Item({ label, value, onChange, selected, col, image, disabled }) {
  return (
    <Column {...col}>
      <OptionContainer
        className={`${getContainerClass(selected, image)} ${disabled && !selected ? "disabled" : ""}`}
        onClick={() => (selected || !disabled) && onChange(value)}>
        {image && (
          <img alt={label} src={`${process.env.NEXT_PUBLIC_CLOUDINARY}w_100,f_auto,q_auto/${image}`} width={100} />
        )}
        {selected && <SelectedIcon Icon={VerifiedFull} />}
        <Label variant="body">{label}</Label>
      </OptionContainer>
    </Column>
  )
}

Item.defaultProps = {
  image: null,
  disabled: false,
  col: null
}

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  col: PropTypes.object,
  image: PropTypes.string,
  disabled: PropTypes.bool
}
